import { t } from '../lib/i18n';

interface SortDropdownProps {
  onSortChange: (sortKey: 'popular' | 'trending' | 'newest') => void;
  currentSort: 'popular' | 'trending' | 'newest';
}

export function SortDropdown({ onSortChange, currentSort }: SortDropdownProps) {
  const translations = t();
  const sortOptions = {
    popular: translations.common.popular,
    trending: translations.common.trending,
    newest: translations.common.new,
  };

  return (
    <div className="relative inline-block text-left">
      <select
        value={currentSort}
        onChange={(e) => onSortChange(e.target.value as 'popular' | 'trending' | 'newest')}
        className="px-4 py-2 rounded-xl glass border border-white/10 text-white/70 hover:text-white hover:border-white/20"
      >
        {Object.entries(sortOptions).map(([key, label]) => (
          <option key={key} value={key}>
            {label}
          </option>
        ))}
      </select>
    </div>
  );
}
